export interface LinkRange {
  url: string;
  index: number;
  length: number;
}

export function getLinkRanges(text: string): LinkRange[] {
  return Array.from(text.matchAll(/https?:\/\/[^\s]+/g)).map((match) => ({
    url: match[0],
    index: match.index as number,
    length: match[0].length,
  }));
}

export function getLinks(text: string): string[] {
  return getLinkRanges(text).map((link) => link.url);
}
